import React from 'react'
import Typography from '../../Typography'

interface Props{
    startDate:string,
    lastModifyDate:string
}

export default function SettingsHeader({startDate,lastModifyDate}:Props) {
  return (
    <div className='flex justify-between items-center'>
      <div>
        <Typography variant='headline3'>
        Pagina Utente
        </Typography>
        <div className='flex'>
          <Typography  variant="button" className='mt-2'>
            Creato il {startDate}
          </Typography>
          {/* <Typography  variant="button" className='mt-2 ms-4'>
            Ultima modifica {lastModifyDate}
          </Typography> */}
        </div>
      </div>
      <div className='me-3'>
      <Typography variant="button" className='mt-2'>
          Calcoli residui
        </Typography>
        <Typography style={{fontWeight:600}} className='mt-2'>
          Infiniti
        </Typography>
      </div>
    </div>
  )
}
